import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Register from './Register';
import RegisterConfirmation from './RegisterConfirmation';
import EmailVerification from './EmailVerification';
import ForgotPassword from './ForgotPassword';
import ResetPassword from './ResetPassword';
import MultiFactorAuthenticationConfirmation from './MultiFactorAuthenticationConfirmation';
import PageNotFound from '../components/PageNotFound';
import AccountInvitation from './AccountInvitation/pages/AccountInvitation';
import AccountInvitationDecline from './AccountInvitationDecline/pages/AccountInvitationDecline';
import UserInvitationDeclineForm from './user-invitation/UserDeclineInvitationForm';
import BuyOwnSubscription from './Accounts/Subscriptions/BuyOwnSubscription';
import OrganizationDetailsStep from './AccountInvitation/components/OrganizationDetailsStep';
import OtherUsersStep from './AccountInvitation/components/OtherUsersStep';

const PublicIndex = () => (
  <div role="presentation">
    <div className="layout-main">
      <Switch>
        <Route path="/user-invitation-decline" component={UserInvitationDeclineForm} />
        <Route path="/account-invitation" component={AccountInvitation} />
        <Route path="/account-invitation/organisation-details" component={OrganizationDetailsStep} />
        <Route path="/account-invitation/other-users" component={OtherUsersStep} />
        <Route path="/account-invitation-decline" component={AccountInvitationDecline} />
        <Route path="/register" component={Register} exact />
        <Route path="/register-confirmation" component={RegisterConfirmation} exact />
        <Route path="/email-verification" component={EmailVerification} exact />
        <Route path="/forgot-password" component={ForgotPassword} exact />
        <Route path="/reset-password" component={ResetPassword} exact />
        <Route path="/multi-factor-confirmation" component={MultiFactorAuthenticationConfirmation} exact />
        <Route path="/buy-own-subscription" component={BuyOwnSubscription} exact />
        <Route component={PageNotFound} />
      </Switch>
    </div>
    <div className="layout-mask" />
  </div>
);

export default PublicIndex;
